import { IFsNodeSchema } from "@cloudike/web_files"
import { LOADING_STATUSES } from "shared/constants/loadingStatuses"

export interface AssetsState {
  status: LOADING_STATUSES
  firstPageStatus: LOADING_STATUSES
  nextPageStatus: LOADING_STATUSES
  error: string | null
  selectedItemsIds: string[]
  lastSelectedIndexes: number[]
  lastSelectedWithShiftIndex: number | null
  renamingItemId: string | null
  areAllAssetsFetched: boolean
  availableAssetsActions: {
    id: string
    name: string
  }[]
  systemFields: IField[]
  currentFolderId: string
  currentFolder: IFsNodeSchema | null
  selectedFilter: string
}

export interface IFieldOption {
  id?: string
  value?: string
  name?: string
  type?: string
}
export interface IField {
  created: string
  updated: string
  user_id: number
  field_type: string
  title: string
  description: string
  options: IFieldOption[]
  id: string
  _links: {
    self: {
      href: string
    }
  }
}

export const FILES_EXTANSIONS_FOR_AI_ASSISTANT_INDEXING = [
  'pdf', 'docx', 'txt', 'pptx', 'eml', 'xlsx', 'csv', 'html', 'md', 'rtf', 'msg'
]